import { styled } from "@mui/material";

import { InfoResponse } from "@/@types/growthos-api/schema/openapi";
import { NavAutocomplete } from "@/Components/v2/atoms/Autocomplete";
import { MenuItem } from "@/Components/v2/atoms/MenuItem";

import { TextField } from "../../atoms/TextField";
import { brandColors } from "../../utils/brand-colors";

const StyledDrawerAccountSelector = styled(MenuItem)(({ theme }) => {
  return {
    backgroundColor:
      theme.palette.mode === "light" ? brandColors.pirateBlack : brandColors.ceasefireWhite,
    color:
      theme.palette.mode === "light"
        ? brandColors.ceasefireWhite
        : brandColors.primaryButtonTextHoverLight,
    fontWeight: 600,
    fontSize: "14px",
    borderRadius: "6px",
    padding: "0.75rem 0.75rem",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "light" ? brandColors.pirateBlack : brandColors.ceasefireWhite, // Keep background color the same on hover
      color:
        theme.palette.mode === "light"
          ? brandColors.ceasefireWhite
          : brandColors.primaryButtonTextHoverLight, // Keep text color the same on hover
    },
  };
});

interface DrawerAccountSelectorProps {
  selectedAccount: InfoResponse["currentOrganization"];
  accounts: InfoResponse["currentOrganization"][];
  onAccountSelected: (account: InfoResponse["currentOrganization"]) => void;
}

export const DrawerAccountSelector: React.FC<DrawerAccountSelectorProps> = ({
  selectedAccount,
  accounts,
  onAccountSelected,
  ...rest
}) => {
  const handleAccountSelected = (
    _event: React.SyntheticEvent<Element, Event>,
    account: InfoResponse["currentOrganization"]
  ) => {
    onAccountSelected(account);
  };

  // If 1 account, assume the one account is the same as `selectedAccount`
  if (accounts.length === 0 || accounts.length === 1) {
    return (
      <StyledDrawerAccountSelector {...rest}>
        {selectedAccount.displayName}
      </StyledDrawerAccountSelector>
    );
  }

  return (
    <NavAutocomplete
      value={selectedAccount}
      options={accounts}
      getOptionLabel={(option: InfoResponse["currentOrganization"]) => option.displayName}
      isOptionEqualToValue={(
        option: InfoResponse["currentOrganization"],
        value: InfoResponse["currentOrganization"]
      ) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
          }}
          fullWidth
          size="medium"
          InputLabelProps={{}}
        />
      )}
      getOptionKey={(option: InfoResponse["currentOrganization"]) => option.id}
      onChange={handleAccountSelected}
      disableClearable
    />
  );
};
